"use client";

import { BreadCrumb } from "@/components/templates";
import styles from "./styles.module.scss";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { realisations } from "../detail-realisation";

import cloture from "../../../assets/images/realisations/cloture.jpg";
import terrasse from "../../../assets/images/realisations/terrasse.jpg";
import jeu_d_eau from "../../../assets/images/realisations/jeu_d_eau.jpg";
import eclairage from "../../../assets/images/realisations/eclairage.jpg";
import terrasse_xl from "../../../assets/images/realisations/terrasse_xl.jpg";

export const Realisations = () => {
  const router = useRouter();

  const handleClick = (index: number) => () => {
    router.push(`/realisations/${realisations[index].slug}`);
  };

  return (
    <>
      <div className={styles.realisations}>
        <BreadCrumb
          className={styles.bread_crumb}
          data={[
            {
              url: "/",
              label: "Accueil",
            },
            {
              url: "/realisations",
              label: "Réalisations",
            },
          ]}
        />
        <h1>Réalisations</h1>
        <p className={styles.first_p}>
          Depuis notre création en 1978, nous nous sommes concentrés sur la
          construction axée sur la conception. Le <span>design</span> reste
          notre point de départ – alimenté par la <span>découverte</span> et le
          défi, et rempli par la réalité tactile du processus de construction.
          <br />
          En accordant la priorité à la durabilité, à l&apos;honnêteté et à
          l&apos;utilisation réfléchie des matériaux, nous guidons la vision,
          repoussons les limites et gérons l&apos;ensemble du processus, de la
          première visite sur site à la livraison du projet.
        </p>
        <div className={styles.images_container}>
          <div className={styles.first_row}>
            <div className={styles.first_image}>
              <div className={styles.label_image}>
                <h2>Clôture</h2>
              </div>
              <div className={styles.image_container} onClick={handleClick(0)}>
                <Image src={cloture} alt="Clôture" />
              </div>
            </div>
            <div className={styles.second_image}>
              <div className={styles.label_image}>
                <h2>Terrasse bois</h2>
              </div>
              <div className={styles.image_container} onClick={handleClick(1)}>
                <Image
                  className={styles.xl}
                  src={terrasse_xl}
                  alt="Terrasse bois"
                />
                <Image
                  className={styles.xl_2}
                  src={terrasse}
                  alt="Terrasse Jaunes"
                />
              </div>
            </div>
          </div>
          <div className={styles.second_row}>
            <div className={styles.first_image}>
              <div className={styles.label_image}>
                <h2>Jeux d’eau</h2>
              </div>
              <div className={styles.image_container} onClick={handleClick(3)}>
                <Image src={jeu_d_eau} alt="Jeux d’eau" />
              </div>
            </div>
            <div className={styles.second_image}>
              <div className={styles.label_image}>
                <h2>Éclairage extérieur</h2>
              </div>
              <div className={styles.image_container} onClick={handleClick(2)}>
                <Image src={eclairage} alt="Éclairage extérieur" />
              </div>
            </div>
          </div>
          {/* <div className={styles.third_row}>
            <div className={styles.first_image}>
              <div className={styles.label_image}>
                <h2>Projet 5</h2>
              </div>
              <div className={styles.image_container} onClick={handleClick(4)}>
                <Image src={img5} alt="Projet 5" />
              </div>
            </div>
            <div className={styles.second_image}>
              <div className={styles.label_image}>
                <h2>Projet 6</h2>
              </div>
              <div className={styles.image_container} onClick={handleClick(5)}>
                <Image src={img6} alt="Projet 6" />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};
